// Re-export generated hooks with user-friendly names
import { enhancedApi } from '@store/generated/data-migration';

export const patientDeduplicationApi = enhancedApi;

// User-friendly hook aliases
export const useFindDuplicatesMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateMutation;

export const useMergePatientGroupMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateMergeMutation;
